/**
 * 加载中图标
 */

import React from 'react';
import { createPortal } from 'react-dom';

interface Props {
    // 是否展示
    visible: boolean;
}

export function GlobalLoading({ visible }: Props) {
    if (!visible) {
        return null;
    }
    const dom = (
        <div>
            <div className="weui-mask_transparent"></div>
            <div className="weui-toast">
                <i className="weui-loading weui-icon_toast"></i>
                <p className="weui-toast__content">数据加载中</p>
            </div>
        </div>
    );
    return createPortal(dom, document.body);
}
